<div class="">
    <mat-dialog-content class="account-box" style="overflow: hidden; scroll-behavior: unset;">
        <div class="text-center">
            <img src="assets/img/Frame.png" alt="">
        </div>

        <div class="accont-created" style="margin-bottom:14px;">
            <h4 style="font-weight: 600; font-size: 20px; color: #1E2A36;">{{ data?.message }}</h4>
        </div>

        <div class="accont-created-desc" style="margin-bottom:14px;">
            {{ data?.message2 }}
        </div>

        <!-- <div class="account-confirm-links text-center" style="margin-bottom:24px;">
            <a class="" (click)="onConfirmClick()">
                DELETE
            </a>
        </div>


        <div class="account-confirm-links text-center">
            <a class="" (click)="onNoClick()">
                CANCEL
            </a>
        </div> -->

        <div class="assessment_pt-10">
            <button class="btn btn-primary btn-block" type="button" (click)="onConfirmClick()">DELETE</button>
        </div>

        <div class="assessment_pt-15">
            <button class="btn-link btn-block resend-otp" (click)="onNoClick()" type="button">CANCEL</button>
        </div>

        </mat-dialog-content>
        </div> 